import SupportCurrencySelect from './SupportCurrencySelect';

export default SupportCurrencySelect;
